import React, { useEffect, useRef, useState } from 'react';
import { Buttons } from './Buttons';

export const AFLDesignSystem = () => {
    const [theme, setTheme] = useState('aflm');
    const [darkMode, setDarkMode] = useState(false);
    const aflDesignSystemRef = useRef();
    const themes = ['aflm', 'aflw', 'finals', 'gather-round'];

    const onThemeChange = (event) => {
        setTheme(event.target.value);
    };

    const onModeChange = (event) => {
        const isDarkMode = event.target.checked;
        setDarkMode(isDarkMode);
    };

    useEffect(() => {
        if (aflDesignSystemRef.current) {
            aflDesignSystemRef.current
                .closest('.afl-design-system')
                .setAttribute(
                    'data-theme',
                    `${theme}${darkMode ? '-dark' : ''}`
                );
        }
    }, [theme, darkMode, aflDesignSystemRef.current]);

    return (
        <div
            className="afl-design-system__content flex flex-column gap-s items-center"
            ref={aflDesignSystemRef}
        >
            <div className="flex flex-row gap-xs items-center justify-start w-100">
                <div className="flex flex-col gap-xs">
                    <label className="text-label-m">Theme</label>
                    <select
                        onChange={onThemeChange}
                        value={theme}
                        className="px-s py-1 rounded text-label-s"
                    >
                        {themes.map((option) => (
                            <option key={`theme-${option}`} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="flex flex-col gap-xs">
                    <input
                        type="checkbox"
                        onChange={onModeChange}
                        checked={darkMode}
                    />
                    <label className="text-label-m">Dark mode</label>
                </div>
            </div>
            <Buttons />
        </div>
    );
};
